import { getListBrowserStore } from '@ts-private/list-browser';

export const documentSyncStatesStore = getListBrowserStore({
  name: 'document-sync-states-browser',
  filterDefinitions: [
    {
      name: 'sourceDocumentType',
      caption: 'DocumentSyncState.SourceDocumentType',
      type: 'text'
    },
    {
      name: 'destinationDocumentType',
      caption: 'DocumentSyncState.DestinationDocumentType',
      type: 'text'
    }
  ],
  orderByFields: [
    {
      caption: 'DocumentSyncState.SourceDocumentType',
      value: 'sourceDocumentTypeName'
    },
    {
      caption: 'DocumentSyncState.DestinationDocumentType',
      value: 'destinationDocumentTypeName'
    }
  ],
  pager: {
    orderBy: 'sourceDocumentTypeName',
    direction: 'asc'
  }
});
